export const popularFastagProviders = {
  'IDFC FIRST Bank FASTag': 'IDFC First Bank',
  'ICICI Bank FASTag': 'ICICI Bank',
  'HDFC Bank FASTag': 'HDFC Bank',
  'State Bank of India - NETC FASTag': 'SBI',
  'Axis Bank Fastag': 'Axis Bank',
  'Airtel Payments Bank NETC FASTag': 'Airtel Payments',
}
